// Header: navigation, version pill, theme switch, settings and sign-out.
// The language switch itself is not in here — its tooltip is deliberately
// written in the language it switches TO, so it reads for someone who cannot
// read the current one.
//
// Key = the exact English source string used in the code. Value = German.
// Do NOT redefine keys already in common.ts.

export const nav: Record<string, string> = {
  // Nav items. "Inbox", "Invoice Analyser", "PO Tracking" and "Admin" are the
  // names the team uses in German too, so they stay as they are.
  Inbox: 'Inbox',
  Dashboard: 'Dashboard',
  'Invoice Analyser': 'Invoice Analyser',
  Database: 'Datenbank',
  'PO Tracking': 'PO-Tracking',
  Admin: 'Admin',

  // Version badge + the "What's new" dialog it opens. The changelog prose itself
  // is not in here — entries in src/changelog.ts carry both languages inline.
  "What's new": 'Was ist neu',
  'All versions': 'Alle Versionen',
  'Since your last visit': 'Seit deinem letzten Besuch',
  'Show all versions': 'Alle Versionen anzeigen',
  'Got it': 'Verstanden',

  // Theme switch
  Light: 'Hell',
  Dark: 'Dunkel',
  'Switch to light mode': 'Zu hellem Modus wechseln',
  'Switch to dark mode': 'Zu dunklem Modus wechseln',

  Settings: 'Einstellungen',
  'Sign out': 'Abmelden',
}
